import { render, staticRenderFns } from "./MonthPlanAdd.vue?vue&type=template&id=f924dc1a&scoped=true&"
import script from "./MonthPlanAdd.vue?vue&type=script&lang=ts&"
export * from "./MonthPlanAdd.vue?vue&type=script&lang=ts&"
import style0 from "./MonthPlanAdd.vue?vue&type=style&index=0&id=f924dc1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f924dc1a",
  null
  
)

export default component.exports